var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k-container-loader",style:(_vm.styleDisplay)},[_c('div',{staticClass:"k-loader"},[_c('div',{staticClass:"k-progress",style:(_vm.styleProgress)},[_c('div',{staticClass:"k-blank-line"})]),_c('span',{staticClass:"progress-porcent"},[_vm._v(_vm._s(this.progress)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }